import { useState, useMemo } from 'react';
import type { VersionTipo } from '../config/versionTypes';

export interface VersionFilters {
  searchTerm: string;
  selectedTypes: VersionTipo[];
  fechaInicio: string;
  fechaFin: string;
}

export function useVersionFilters() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTypes, setSelectedTypes] = useState<VersionTipo[]>([]);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  const hasActiveFilters = useMemo(() => {
    return !!(
      searchTerm.trim() ||
      selectedTypes.length > 0 ||
      fechaInicio ||
      fechaFin
    );
  }, [searchTerm, selectedTypes, fechaInicio, fechaFin]);

  const resetFilters = () => {
    setSearchTerm('');
    setSelectedTypes([]);
    setFechaInicio('');
    setFechaFin('');
  };

  const toggleType = (tipo: VersionTipo) => {
    setSelectedTypes(prev =>
      prev.includes(tipo)
        ? prev.filter(t => t !== tipo)
        : [...prev, tipo]
    );
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedTypes,
    setSelectedTypes,
    toggleType,
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    hasActiveFilters,
    resetFilters,
  };
}
